const { APP_VISION } = require("./routes");

module.exports = {
  STORE_WEBSITE: 'https://terravirtua.io/',
  ETH_TRANSACTION_HASH_LINK: 'https://etherscan.io/tx/',
  MATIC_TRANSACTION_HASH_LINK: 'https://polygonscan.com/tx/',
  TEZOS_TRANSACTION_HASH_LINK: 'https://better-call.dev/granadanet/KT19oSa4uQA1GyLy94yGPJymBWo8nMxbjNia/operations',
  TRANSACTION_URL: 'https://transaction.terravirtua.io/',
  API_URL: {
    URL: 'https://api.terravirtua.io/',
    ADMIN_API: 'https://console.terravirtua.io/',
    ADMIN_TRADING_API: 'https://admintradeapi.terravirtua.io/',
    TRADING_API: 'https://trade.terravirtua.io/',
    ADMIN_COLLECTION_API: 'https://collection.terravirtua.io/admin/',
    ADMIN_REFILL_API: 'https://collection.terravirtua.io/',
    ITEM_URL: 'https://item.terravirtua.io/',
  },
  LOOKUPS: {
    URL: 'https://tvassets.s3.eu-west-2.amazonaws.com/lookups/prod-lookup.json'
  },
  S3: {
    URL: 'https://tv-inventory.s3.eu-west-2.amazonaws.com'
  },
  META_MASK: {
    LINK: 'https://etherscan.io/token/0xdc76a2de1861ea49e8b41a1de1e461085e8f369f?a='
  },
  MATIC_META_MASK: {
    LINK: "https://polygonscan.com/token/0x141d8a900Ee841F8F2e6Bd8c4c1b7c89fd0Fc56e?a=",
  },
  TEZOS_META_MASK: {
    LINK: "https://better-call.dev/granadanet/KT19oSa4uQA1GyLy94yGPJymBWo8nMxbjNia/operations",
  },
  APP_VISION:'https://terravirtua.apvision.org/app-upload'
}